import { render, staticRenderFns } from "./cleanPoint.vue?vue&type=template&id=7416edfb&scoped=true&"
import script from "./cleanPoint.vue?vue&type=script&lang=js&"
export * from "./cleanPoint.vue?vue&type=script&lang=js&"
import style0 from "./cleanPoint.vue?vue&type=style&index=0&id=7416edfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7416edfb",
  null
  
)

export default component.exports